export default __webpack_public_path__ + "static/media/on.23aa3dd9.svg";